module.exports = "/packs/media/images/saving2-1f76addd64d1d98af330b1bed757b8f4.jpg";